module.exports = __webpack_public_path__ + "static/media/contact_primary.28f617d2.svg";